import { createContext } from "react";

type ExpansionHandler = (citationNumber: number) => void;

interface CitationExpansionContextType {
  registerExpansionHandler: (
    messageId: string,
    handler: ExpansionHandler,
  ) => () => void;
  expandCitation: (messageId: string, citationNumber: number) => void;
}

export const CitationExpansionContext = createContext<
  CitationExpansionContextType | undefined
>(undefined);
